/** Normaliza PLU de balanza a 5 dígitos (ej. 36 → 00036). */
export function normalizePluBalanza(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.slice(-5).padStart(5, '0');
}

/** Lee pluBalanza / plu_balanza del producto. */
export function getProductPluBalanza(producto) {
  const raw = producto?.pluBalanza ?? producto?.plu_balanza ?? '';
  return normalizePluBalanza(raw);
}

/** ¿El producto corresponde al PLU escaneado? */
export function productMatchesPlu(producto, pluNorm) {
  if (!producto || !pluNorm) return false;
  const pluProducto = getProductPluBalanza(producto);
  if (pluProducto && pluProducto === pluNorm) return true;
  return normalizePluBalanza(producto?.codigo) === pluNorm;
}
